import { t } from 'i18next';
import * as PosService from '../../Services/pos-service'
import NoteAddRoundedIcon from '@mui/icons-material/NoteAddRounded';

function PosRequestSuccessForm({ setLoading, setObjectDto, lang }) {
    const windowSize = PosService.getSizeWindows();
    return (
        <>
            <div>
                <div className="collapse in" id="search-box-6">
                    <div className="border-box-sc row">
                        <div className="col-md-12 ">
                            <div className="form-group col-md-12">
                                <div className="col-md-12" style={{ textAlign: "center" }}>
                                    <ul>
                                        <li>
                                            <i className="fa fa-check-circle" aria-hidden="true" style={{ fontSize: windowSize[0] < 600 ? "25px" : "50px", color: "green" }} />{" "}
                                        </li>
                                        <li>
                                            <span style={{ fontSize: windowSize[0] < 600 ? "11px" : "13px" }}>{t("messagesuccesssendrequestlabel").toUpperCase() + ". " + t("messagesuccesssendrequesttoemaillabel").toUpperCase() + "."}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12" id="submitDiv" style={{ marginBottom: "10%" }}>
                <a id="btnClose" className="btn-common btn-search description-small-customer"
                    onClick={() => {
                        setLoading(true);
                        PosService.HandleClose(setObjectDto, setLoading);
                    }}>
                    <NoteAddRoundedIcon style={{ marginRight: "5px", marginBottom: "-3px" }} />
                    <span>
                        {lang('buttonnewform').toUpperCase()}
                    </span>
                </a>
            </div>
        </>
    )
}
export default PosRequestSuccessForm;